import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const ActionSheetChartContainer = styled('div')`
  padding: 0px ${({ theme }) => theme.x2spacePx}px;
  height: 324px;

  ${media.mdUp`
    padding: 0px;
  `}
`;

export const ActionSheetTableContainer = styled('div')`
  background: ${({ theme }) => theme.color.charcoal};
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

interface TableOverflowProps {
  side: 'top' | 'bottom';
  expanded?: boolean;
}

interface TableHeaderBackgroundProps {
  expanded?: boolean;
}

export const TableOverflowWrapper = styled('div')`
  position: relative;
`;

export const TableOverflowEdges = styled('div')<TableOverflowProps>`
  position: absolute;
  pointer-events: none;
  left: 0;
  right: 0;
  ${({ side, expanded }) =>
    side === 'top'
      ? expanded === true
        ? 'top: 108px'
        : 'top: 30px'
      : 'bottom: 0'};
  width: 100%;
  height: 20px;

  ${media.smDown`
    ${({ side, expanded }) =>
      side === 'top'
        ? expanded === true
          ? 'top: 148px'
          : 'top: 48px'
        : 'bottom: 0'};
  `}
`;

export const TableOverflowShadow = styled('div')<TableOverflowProps>`
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 36px;
  left: 0;
  right: 0;
  ${({ side, expanded }) =>
    side === 'top'
      ? expanded === true
        ? 'top: 108px'
        : 'top: 30px'
      : 'bottom: 0'};

  background: ${({ side, theme }) =>
    `linear-gradient(${side === 'top' ? 0 : 180}deg, rgba(21, 27, 36, 0) 0%, ${
      theme.color.charcoal
    } 100%);`};

  ${media.smDown`
    ${({ side, expanded }) =>
      side === 'top'
        ? expanded === true
          ? 'top: 148px'
          : 'top: 48px'
        : 'bottom: 0'};
  `}
`;

export const DataTableContainer = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const ActionSheetTabContainer = styled('div')`
  background: ${({ theme }) => theme.color.charcoal};
  width: 100%;
`;

export const TableHeaderBackground = styled('div')<TableHeaderBackgroundProps>`
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  background: ${({ theme }) => theme.color.charcoal};
  border-radius: 4px;

  height: ${({ expanded }) => (expanded === true ? '108px' : '30px')};
  ${media.smDown`
    height: ${({ expanded }) => (expanded === true ? '148px' : '48px')};
  `}
`;

export const NoMoreCompanies = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  height: ${({ theme }) => theme.x6spacePx}px;
`;
